import React from 'react';
import FormSelect from 'components/Select';
import { Box } from 'reflexbox';
import PropTypes from 'prop-types';
import InlineAlert from '@ikea-ux/inline-alert';

import Text from 'components/Text';

import appStorage from 'helpers/AppStorage';
import { getText } from 'helpers/i18n';

import './storeSelector.styles.scss';
import '@ikea-ux/svg-icon/dist/style.css';
import '@ikea-ux/inline-alert/dist/style.css';

export default class StoreSelector extends React.Component {
    componentDidMount() {
        const { getStores, changeStore} = this.props;

        // Loads available stores
        getStores();

        // Set already saved selected store
        if (appStorage('selectedStore')) {
            changeStore(appStorage('selectedStore'));
        }
    }

    onStoreChange(name, value) {
        const { changeStore } = this.props;
        changeStore(value);
    }

    render() {
        const { stores, selectedStore, productCount, shoppingListView } = this.props;

        if (stores.length === 0 || productCount === 0 || shoppingListView === 'buyonline') {
            return null;
        }

        // Is there only one store? If so select it and don’t render the component
        if (stores.length === 2) {
            if (!selectedStore || selectedStore === '0') {
                this.onStoreChange(stores[1].name, stores[1].value);
            }
            return (
                <Box w={1} pb={2} className="storeselector">
                    <p className="storeselector__text">
                        <Text textKey="select_store_preselected" options={{
                            store: stores[1].name,
                        }} />
                    </p>
                </Box>
            );
        }

        return (
            <Box w={1} pb={2} className="storeselector">
                { selectedStore === '0' &&
                    <InlineAlert
                        type="warning"
                        size="s"
                        message={<Text textKey="select_store_warning"/>}
                    />
                }
                <Box auto mt={1}>
                    <FormSelect
                        options={stores}
                        id="storeselector"
                        name="storeselector"
                        ariaLabel={getText('select_store_label')}
                        onChange={this.onStoreChange.bind(this)}
                        defaultValue={selectedStore}
                    />
                </Box>
            </Box>
        );
    }
}

StoreSelector.propTypes = {
    stores: PropTypes.array.isRequired,
    selectedStore: PropTypes.string.isRequired,
    changeStore: PropTypes.func.isRequired,
    getStores: PropTypes.func.isRequired,
    productCount: PropTypes.number.isRequired,
    shoppingListView: PropTypes.string,
};
